export default __webpack_public_path__ + "static/media/featured_img1.328b6b3e.png";